module.exports = __webpack_public_path__ + "755b04d8b050da99532289b51ca671ab.fbx";